import { Link } from 'react-router-dom';
import { SiteHeader } from '@/components/layout/SiteHeader';
import { SiteFooter } from '@/components/layout/SiteFooter';

export function NotFoundPage() {
  return (
    <div className="min-h-screen flex flex-col">
      <SiteHeader />
      <main className="flex-1 mx-auto max-w-3xl px-6 py-24 text-center">
        <p className="num text-sm uppercase tracking-wide text-accent-600 font-semibold">404</p>
        <h1 className="display text-4xl md:text-5xl font-semibold tracking-tight text-ink-900 mt-3 serif-jp">
          That page isn't here.
        </h1>
        <p className="mt-3 text-ink-600">
          It may have been moved, or the link is incorrect. Try one of these instead:
        </p>
        <div className="mt-6 flex flex-wrap justify-center gap-3">
          <Link to="/" className="inline-flex items-center px-4 py-2 rounded-lg border border-ink-300 text-ink-900 text-sm font-semibold hover:bg-ink-100 transition">Home</Link>
          <Link to="/pricing" className="inline-flex items-center px-4 py-2 rounded-lg border border-ink-300 text-ink-900 text-sm font-semibold hover:bg-ink-100 transition">Pricing</Link>
          <Link to="/compare" className="inline-flex items-center px-4 py-2 rounded-lg border border-ink-300 text-ink-900 text-sm font-semibold hover:bg-ink-100 transition">Compare</Link>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}
